import { injectReducer } from '../../../store/reducers';
import { injectSagas } from '../../../store/sagas';


export default store => ({
  path : '/profile/billing-info',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      const BillingInfoContainer = require('./containers/BillingInfo.js').default;
      const reducer = require('reducers/user').default;
      const sagas = require('sagas/sagas').default;

      injectReducer(store, { key: 'user', reducer });
      injectSagas(store, { key: 'sagas', sagas });

      cb(null, BillingInfoContainer);
    }, 'billingInfo');
  },
});



// WEBPACK FOOTER //
// /Users/balazskaxd/dev/rkk/rkk-webapp/src/routes/Profile/BillingInfo/index.js